<template>
  <v-flex
    xs6
    md4
  >
    <v-select
      ref="tankId"
      :value="selectedId"
      :items="tankSelection"
      class="purple-input"
      label="タンクID"
      @input="$emit('input', $event)"
    >
      <!-- タンク追加ボタン -->
      <template v-slot:append-item>
        <v-divider
          dark
        />
        <v-list-tile
          style="margin-bottom: -8px;"
          :title="isNewTank ? '先に追加済みのタンクを更新してください。' : ''"
          @click="addTankId"
        >
          <v-icon
            color="green"
            style=""
            :disabled="isNewTank"
          >
            mdi-plus
          </v-icon>
          <span style="color:gray">追加</span>
        </v-list-tile>
      </template>
      <!--  -->

      <!-- タンク削除ボタン -->
      <template
        slot="item"
        slot-scope="data"
      >
        <template>
          <div
            class="option-div"
          >
            <v-list-tile-content>
              <v-list-tile-title
                style="opacity:1!important;font-size:16px"
                v-text="data.item.text"
              />
            </v-list-tile-content>

            <v-icon
              v-if="tankSelection.length > 1"
              class="close-icon"
              color="red"
              @click.stop="onTankDeletionClicked(data.item)"
            >
              mdi-close
            </v-icon>
          </div>
        </template>
      </template>
      <!--  -->
    </v-select>
    <ConfirmDialog
      v-model="showTankDeletionDialog"
      :loading="deleteLoading"
      @confirm="deleteTank"
      @cancel="showTankDeletionDialog = false"
    >
      タンクID：{{ tankDeletionId }} のタンクを削除しますか？<br>
      （この操作はやり直しできません。）
    </ConfirmDialog>
  </v-flex>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { ConfirmDialog } from '@/components/dialog'
export default {
  components: {
    ConfirmDialog
  },
  props: {
    tankSelection: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: [Number, String],
      default: () => null
    },
    customerId: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
      showTankDeletionDialog: false,
      tankDeletionId: null,
      deleteLoading: false
    }
  },
  computed: {
    isNewTank () {
      return this.selectedId === 'new'
    }
  },
  methods: {
    ...mapMutations('app', ['setGlobalSnackBarText']),
    ...mapActions('customers', ['deleteCustomerTank']),
    addTankId () {
      if (this.isNewTank) return

      this.$emit('input', 'new')
      this.$refs.tankId.blur()
    },
    onTankDeletionClicked (item) {
      // ばつボタンを押したのが登録前の新しいタンクだったら確認せずに削除
      if (item.text === 'new') {
        this.$refs.tankId.blur()
        return this.$emit('remove-new-tank')
      }
      // じゃなければタンク削除のダイアログを開く
      this.tankDeletionId = item.value
      this.showTankDeletionDialog = true
    },
    async deleteTank () {
      this.deleteLoading = true
      const data = {
        customerId: this.customerId,
        tankId: this.tankDeletionId
      }
      try {
        await this.deleteCustomerTank(data)
        const id = this.selectedId === this.tankDeletionId
          ? null
          : this.selectedId
        this.$emit('input', id)
        this.setGlobalSnackBarText(`ID: ${this.tankDeletionId}のタンクを削除しました。`)
        this.showTankDeletionDialog = false
        this.tankDeletionId = null
      } finally {
        this.deleteLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.option-div{
  display:contents;
  &:hover{
    .close-icon{
      opacity: 1;
    }
  }
}
.close-icon{
  margin: 0px -10px 0px 0px;
  transform:scale(0.8);
  opacity: 0;
}
</style>
